var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    { attrs: { widget: _vm.widgetTitle } },
    [
      _c(
        "v-table",
        {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.billingMonths,
            "current-page": _vm.currentPage,
            "page-size": 10,
            "hide-sort-icons": true
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function({ displayData }) {
                return _c(
                  "tbody",
                  {},
                  _vm._l(displayData, function(row) {
                    return _c("tr", { key: row.readableDt }, [
                      _c("td", [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(row.readableDt)) + "  "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-list-function",
                            on: {
                              click: function($event) {
                                return _vm.exportInvoice(row)
                              }
                            }
                          },
                          [
                            _c("i", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right.hover",
                                  value: {
                                    text: _vm.$t("DOWNLOAD_INVOICE_MONTH"),
                                    transition: 0
                                  },
                                  expression:
                                    "{ text:$t('DOWNLOAD_INVOICE_MONTH'), transition: 0 }",
                                  modifiers: { right: true, hover: true }
                                }
                              ],
                              staticClass: "fa fa-download",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        )
                      ])
                    ])
                  }),
                  0
                )
              }
            }
          ])
        },
        [
          _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
            _c(
              "tr",
              [
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "REFERENCE_PERIOD",
                      expression: "'REFERENCE_PERIOD'"
                    }
                  ],
                  attrs: { "sort-key": "readableDt" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "INVOICE",
                      expression: "'INVOICE'"
                    }
                  ],
                  attrs: { "sort-key": "readableDt" }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
                "max-page-links": 10
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.tableEmpty
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "BILLING_MONTHS_TABLE_EMPTY",
                expression: "'BILLING_MONTHS_TABLE_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }